module.exports = __webpack_public_path__ + "img/icon-contractor.fe6ed7fc.png";